import type { PresentationModule } from '../../presentation/types';
import { researchSpace, researchApproval } from './content';
import { ResearchSpaceScene } from './scenes/ResearchSpaceScene';
import { ResearchApprovalScene } from './scenes/ResearchApprovalScene';

/** Moderta AI — Research Space, in the slot the Orchestrator section used to occupy. */
export const researchSpaceModule: PresentationModule = {
  id: 'research-space',
  label: 'Moderta AI — Research Space',
  priority: 'major',
  scenes: [
    { ...researchSpace, module: 'research-space', create: (resolved) => new ResearchSpaceScene(resolved) },
    { ...researchApproval, module: 'research-space', create: (resolved) => new ResearchApprovalScene(resolved) },
  ],
};
